import type { BadgeProps } from './types';

export const Badge = ({ label, variant = 'default' }: BadgeProps) => {
  const base =
    'inline-block rounded px-2 py-0.5 text-[11px] whitespace-nowrap border';
  const styles =
    variant === 'green'
      ? 'bg-[#21262d] border-[#238636] text-[#3fb950]'
      : 'bg-[#21262d] border-[#30363d] text-[#8b949e]';

  return <span className={`${base} ${styles}`}>{label}</span>;
};
